import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-aa5b333e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ecosystem-heading"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, "→", -1));

const _hoisted_3 = {
  class: "ecosystem-grid"
};
const _hoisted_4 = {
  class: "ecosystem-copy"
};
const _hoisted_5 = {
  class: "ecosystem-art",
  "aria-hidden": "true"
};
const _hoisted_6 = ["src"];
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import walletImage from '@/assets/home1/ecosystem-wallet.png';
import swapImage from '@/assets/home1/ecosystem-swap.png';
import earnImage from '@/assets/home1/ecosystem-earn.png';
import launchpadImage from '@/assets/home1/ecosystem-launchpad.png';
import commoditiesImage from '@/assets/home1/ecosystem-nft.png';
import indicesImage from '@/assets/home1/ecosystem-chain.png';
import { getHomePageCopy } from '@/util/homePageCopy';
export default {
  __name: 'HomeEcosystem',

  setup(__props) {
    const router = useRouter();
    const {
      locale
    } = useI18n();
    const copy = computed(() => getHomePageCopy(locale.value).ecosystem);
    const ecosystemTitleId = 'mobile-ecosystem-title';
    const products = computed(() => [{
      id: 'wallet',
      ...copy.value.products.wallet,
      image: walletImage
    }, {
      id: 'swap',
      ...copy.value.products.swap,
      image: swapImage
    }, {
      id: 'earn',
      ...copy.value.products.earn,
      image: earnImage
    }, {
      id: 'launchpad',
      ...copy.value.products.launchpad,
      image: launchpadImage
    }, {
      id: 'commodities',
      ...copy.value.products.commodities,
      image: commoditiesImage
    }, {
      id: 'indices',
      ...copy.value.products.indices,
      image: indicesImage
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", {
        class: "home-ecosystem",
        "aria-labelledby": ecosystemTitleId
      }, [_createElementVNode("header", _hoisted_1, [_createElementVNode("h2", {
        id: ecosystemTitleId
      }, _toDisplayString(_unref(copy).title), 1), _createElementVNode("button", {
        class: "all-products",
        type: "button",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push({
          name: 'futures'
        }))
      }, [_createTextVNode(_toDisplayString(_unref(copy).allProducts) + " ", 1), _hoisted_2])]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), product => {
        return _openBlock(), _createElementBlock("article", {
          key: product.id,
          class: "ecosystem-card"
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", null, _toDisplayString(product.title), 1), _createElementVNode("p", null, _toDisplayString(product.description), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: product.image,
          alt: ""
        }, null, 8, _hoisted_6)])]);
      }), 128))])]);
    };
  }

};